import { COMPARISON_OPERATORS } from '@witmetrics/utils/constants';
import type { DecoratedOrder } from '@witmetrics/utils';
import { buildColumnFilter } from '@witmetrics/utils/filters';
import { API } from '@/api';
import { DEFAULT_PARAMS } from './constants';

export const classes = {
  overlay: 'flex w-[96vw] max-w-[1200px]',
};

export async function fetchLabOrderData(orderId: number, labId: number) {
  const order = await API.Orders.fetchOrder(orderId);
  const [notes, tasks, keypoints, labUsers, keypointTypes, labPractice] =
    await Promise.all([
      fetchOrderNotes(orderId),
      fetchOrderTasks(orderId),
      fetchOrderKeypoints(orderId),
      fetchLabUsers(labId),
      fetchKeypointTypes(labId),
      fetchOrderPractice(order),
    ]);
  return {
    order,
    notes,
    tasks,
    keypoints,
    labUsers,
    keypointTypes,
    labPractice,
  };
}

async function fetchOrderPractice(order: DecoratedOrder) {
  if (!order.practiceId) return undefined;
  return (
    await API.Labs.fetchLabPractices(order.labId, {
      filters: [
        buildColumnFilter(
          'practiceId',
          COMPARISON_OPERATORS.EQUALS.value,
          order.practiceId
        ),
      ],
      pagination: { page: 1, pageSize: 1 },
    })
  ).results[0];
}

async function fetchOrderTasks(orderId: number) {
  return (await API.Orders.fetchOrderTasks(orderId, DEFAULT_PARAMS)).results;
}

async function fetchOrderNotes(orderId: number) {
  return (await API.Orders.fetchOrderNotes(orderId, DEFAULT_PARAMS)).results;
}

async function fetchOrderKeypoints(orderId: number) {
  return (await API.Orders.fetchOrderKeypoints(orderId, DEFAULT_PARAMS))
    .results;
}

async function fetchLabUsers(labId: number) {
  return (
    await API.Labs.fetchLabUsers(labId, {
      filters: [],
      pagination: { page: 1, pageSize: 100 },
    })
  ).results;
}

async function fetchKeypointTypes(labId: number) {
  // TODO: Should fetch additional results if pagination.pageCount > 1
  return (
    await API.Labs.fetchLabKeypointTypes(labId, {
      pagination: { page: 1, pageSize: 250 }, // Just doing a giant page size to fetch everything
    })
  ).results;
}
